<template>
  <el-form-item :label="i18nt('designer.setting.title')">
    <el-input type="text" v-model="optionModel.title"></el-input>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"
  import propertyMixin from "../propertyMixin"

  export default {
    name: "title-editor",
    mixins: [i18n, propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// title-editor.vue?75deb968